import { render, staticRenderFns } from "./ServiceManage.vue?vue&type=template&id=640fcc8d&scoped=true"
import script from "./ServiceManage.vue?vue&type=script&lang=js"
export * from "./ServiceManage.vue?vue&type=script&lang=js"
import style0 from "./ServiceManage.vue?vue&type=style&index=0&id=640fcc8d&prod&lang=scss&scoped=true"
import style1 from "./ServiceManage.vue?vue&type=style&index=1&id=640fcc8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fcc8d",
  null
  
)

export default component.exports